<!-- basic-loan-info.component.html -->
<!-- Basic Loan Info Tab Content -->

<p-card header="Loan Details" [style]="{ width: '100%' }">
  <div class="formgrid grid">
    <!-- Principal Amount -->
    <div class="field col">
      <label for="loanAmount">
        Principal Amount
        <i
          class="pi pi-info-circle tooltip-icon"
          (click)="showTooltip($event, principalTooltip)"
        ></i>
      </label>

      <p-inputgroup>
        <p-inputgroup-addon>$</p-inputgroup-addon>
        <p-inputNumber
          inputId="loanAmount"
          [(ngModel)]="lendPeak.amortization.jsLoanAmount"
          (ngModelChange)="inputChanged($event)"
          mode="decimal"
          minFractionDigits="2"
          maxFractionDigits="2"
          class="w-full"
        ></p-inputNumber>
        <p-inputgroup-addon
          >{{ lendPeak.amortization.totalLoanAmount.toNumber() | currency }}
        </p-inputgroup-addon>
      </p-inputgroup>

      <!-- Popover for Principal Tooltip -->
      <p-popover #principalTooltip>
        <ng-template pTemplate="content">
          The initial amount of the loan. E.g., $100,000
        </ng-template>
      </p-popover>
    </div>

    <!-- Origination Fee -->
    <div class="field col">
      <label for="originationFee">
        Origination Fee
        <i
          class="pi pi-info-circle tooltip-icon"
          (click)="showTooltip($event, originationFeeTooltip)"
        ></i>
      </label>

      <p-inputgroup>
        <p-inputgroup-addon>$</p-inputgroup-addon>

        <p-inputNumber
          inputId="originationFee"
          [(ngModel)]="lendPeak.amortization.jsOriginationFee"
          (ngModelChange)="inputChanged($event)"
          mode="decimal"
          minFractionDigits="2"
          maxFractionDigits="2"
          class="w-full"
        ></p-inputNumber>
      </p-inputgroup>

      <!-- Popover for Origination Fee Tooltip -->
      <p-popover #originationFeeTooltip>
        <ng-template pTemplate="content">
          <div>
            The fee charged by the lender for processing the loan. E.g., $1,000
          </div>
        </ng-template>
      </p-popover>
    </div>
  </div>

  <div class="formgrid grid">
    <!-- Interest Rate (%) -->
    <div class="field col">
      <label for="interestRate">
        Interest Rate (1% = 0.01)
        <i
          class="pi pi-info-circle tooltip-icon"
          (click)="showTooltip($event, interestRateTooltip)"
        ></i>
      </label>

      <!-- Popover for Interest Rate Tooltip -->
      <p-popover #interestRateTooltip>
        <ng-template pTemplate="content">
          Annual interest rate for the loan. E.g., 5%
        </ng-template>
      </p-popover>

      <p-inputgroup>
        <p-inputNumber
          inputId="interestRate"
          [(ngModel)]="lendPeak.amortization.jsAnnualInterestRate"
          (ngModelChange)="inputChanged($event)"
          mode="decimal"
          minFractionDigits="2"
          maxFractionDigits="10"
        ></p-inputNumber>

        <p-inputgroup-addon
          >{{
            (lendPeak.amortization.jsAnnualInterestRate * 100).toFixed(4)
          }}
          %</p-inputgroup-addon
        >
      </p-inputgroup>
    </div>

    <!-- Term (Months) -->
    <div class="field col">
      <label for="term">
        Term ({{ lendPeak.amortization.term }} months)
        <i
          class="pi pi-info-circle tooltip-icon"
          (click)="showTooltip($event, termTooltip)"
        ></i>
      </label>
      <p-inputNumber
        inputId="term"
        [(ngModel)]="lendPeak.amortization.jsTerm"
        (ngModelChange)="inputChanged($event)"
        class="w-full"
      ></p-inputNumber>

      <!-- Popover for Term Tooltip -->
      <p-popover #termTooltip>
        <ng-template pTemplate="content">
          Number of periods for the loan term. E.g., 12
        </ng-template>
      </p-popover>
    </div>
  </div>

  <div class="grid">
    <div class="col">
      <label for="startDate">
        Start Date
        <i
          class="pi pi-info-circle tooltip-icon"
          (click)="showTooltip($event, startDateTooltip)"
        ></i>
      </label>
      <p-datepicker
        appendTo="body"
        inputId="startDate"
        [(ngModel)]="lendPeak.amortization.jsStartDate"
        (ngModelChange)="inputChanged($event)"
        dateFormat="yy-mm-dd"
        [numberOfMonths]="2"
        [showButtonBar]="true"
        [showIcon]="true"
        [style]="{ width: '100%' }"
        [inputStyle]="{
          width: '100%',
          'border-radius': 'unset',
          'font-size': '1.1rem',
        }"
      ></p-datepicker>

      <!-- Popover for Start Date Tooltip -->
      <p-popover #startDateTooltip>
        <ng-template pTemplate="content">
          The date when the loan starts. E.g., 01/01/2024
        </ng-template>
      </p-popover>
    </div>

    <div class="col">
      <label for="firstPaymentDate"
        >First Payment Date
        <i
          class="pi pi-info-circle tooltip-icon p-ml-2"
          (click)="showTooltip($event, firstPaymentDateTooltip)"
        ></i>
      </label>
      <p-inputgroup>
        <p-inputgroup-addon>
          <p-checkbox
            id="enableFirstPaymentDate"
            name="enableFirstPaymentDate"
            [(ngModel)]="lendPeak.amortization.jsHasCustomFirstPaymentDate"
            (ngModelChange)="inputChanged($event)"
            binary="true"
            inputId="enableFirstPaymentDate"
            size="small"
          ></p-checkbox>
        </p-inputgroup-addon>

        <p-datepicker
          inputId="firstPaymentDate"
          [(ngModel)]="lendPeak.amortization.jsFirstPaymentDate"
          (ngModelChange)="inputChanged($event)"
          dateFormat="yy-mm-dd"
          [numberOfMonths]="2"
          [showButtonBar]="true"
          [maxDate]="lendPeak.amortization.jsEndDate"
          [disabled]="!lendPeak.amortization.jsHasCustomFirstPaymentDate"
          [style]="{ width: '100%' }"
          appendTo="body"
          [inputStyle]="{
            width: '100%',
            'border-radius': 'unset',
            'font-size': '1.1rem',
          }"
          class="w-full"
        >
        </p-datepicker>
        <p-inputgroup-addon>
          <i class="pi pi-calendar"></i>
        </p-inputgroup-addon>
      </p-inputgroup>

      <!-- Popover for First Payment Date Tooltip -->
      <p-popover #firstPaymentDateTooltip>
        <ng-template pTemplate="content">
          The date of the first payment. E.g., 02/01/2024
        </ng-template>
      </p-popover>
    </div>

    <div class="col">
      <label for="enableEndDate"
        >End Date
        <i
          class="pi pi-info-circle tooltip-icon p-ml-2"
          (click)="showTooltip($event, endDateTooltip)"
        ></i>
      </label>
      <p-inputgroup>
        <p-inputgroup-addon>
          <p-checkbox
            inputId="enableEndDate"
            [(ngModel)]="lendPeak.amortization.jsHasCustomEndDate"
            binary="true"
            inputId="enableEndDate"
            (ngModelChange)="inputChanged($event)"
            size="small"
          ></p-checkbox>
        </p-inputgroup-addon>

        <p-datepicker
          inputId="endDate"
          [(ngModel)]="lendPeak.amortization.jsEndDate"
          (ngModelChange)="inputChanged($event)"
          dateFormat="yy-mm-dd"
          [numberOfMonths]="2"
          [showButtonBar]="true"
          [disabled]="!lendPeak.amortization.jsHasCustomEndDate"
          [style]="{ width: '100%' }"
          appendTo="body"
          [inputStyle]="{
            width: '100%',
            'border-radius': 'unset',
            'font-size': '1.1rem',
          }"
          class="w-full"
        >
        </p-datepicker>
        <p-inputgroup-addon>
          <i class="pi pi-calendar"></i>
        </p-inputgroup-addon>
      </p-inputgroup>

      <!-- Popover for End Date Tooltip -->
      <p-popover #endDateTooltip>
        <ng-template pTemplate="content">
          The date when the loan ends. Calculated automatically if not set.
        </ng-template>
      </p-popover>
    </div>
  </div>
</p-card>
